import React from 'react';
import {FieldTableColumnProps} from "../../components/FieldTable/FieldTableTypes";
import {SideList} from "../../components/SideList";
import { GetPosterSizeImageDocument, GetPosterSizesForImagesDocument, PosterSize } from '../../generated/graphql';


const PosterSizeImages = () => {
    const columns: FieldTableColumnProps<PosterSize>[] = [
        {
            accessor: 'name',
            header: 'Poster Size',
            dataType: 'link',
            readOnly: true,
            options: {
                getLink:({field, row}) => {
                    return ({
                        pathname: '/database/postersize-images/' + (row.id)
                    });
                }
            }
        }
    ];
    return <SideList
        label="Poster Size Images"
        skipScroll={true}
        className="poster_size_images"
        permission="poster-sizes"
        hasDelete={false}
        getResults={(e)=>e.posterSizes}
        query={GetPosterSizesForImagesDocument}
        columns={columns}
        baseUrl="/database/postersize-images/"
    />;
}

export default PosterSizeImages;